// ---> sales <---
import priyankaImage from "../../../image/homePage/ourTeam/Sales/priyanka.jpg";
import alosiaImage from "../../../image/homePage/ourTeam/Sales/alosia.jpg";
import Sidharh from "../../../image/homePage/ourTeam/Dev/Sidhardh.jpeg";
import Hanna from "../../../image/homePage/ourTeam/Dev/Hanna_J.jpeg";
import Roshni from "../../../image/homePage/ourTeam/Dev/Roshni.R.jpeg";
import Shifa from "../../../image/homePage/ourTeam/Dev/shifa.jpeg";
// ---> Design <---
import porusImage from "../../../image/homePage/ourTeam/Design/porus.jpg";
import suneelImage from "../../../image/homePage/ourTeam/Design/sunil.jpg";
//  ---->Dev<---
import rahulImage from "../../../image/homePage/ourTeam/Dev/rahul.jpg";
import chetanImage from "../../../image/homePage/ourTeam/Dev/chetan.jpg";
import rohitImage from "../../../image/homePage/ourTeam/Dev/rohit.jpg";
import rishikaImage from "../../../image/homePage/ourTeam/Dev/rishika.jpg";
import sanjeevImage from "../../../image/homePage/ourTeam/Dev/sanjeev.jpg";
import priyaImage from "../../../image/homePage/ourTeam/Dev/Priya_malviya.jpeg";
import kritikaImage from "../../../image/homePage/ourTeam/Dev/kritika.jpg";

import mailLogo from "../../../image/socialLogos/teamMailIcon.svg";
import linkdinLogo from "../../../image/socialLogos/teamLinkedinIcon.svg";


export const mobileCarouselData = [
  {
    row1: [
      {
        name: "Porus Rathore",
        details: (
          <>
            CEO
            <br></br>
            Leader | Serial Entrepreneur | Product Strategy Expert
          </>
        ),
        image: porusImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:porus.rathore@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/porusrathore/"
      },
      {
        name: "Priyanka Ganguly",
        details: (
          <>
            CFO
            <br></br>
            Business Development Expert
          </>
        ),
        image: priyankaImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:priyanka.ganguly@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/priyankaganguly "
      }
    ],
    row2: [
      {
        name: "Alosia Rose",
        details: "Marketing Head",
        image: alosiaImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:alosia.rose@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/alosiasheelarose/"
      },
      {
        name: "Sunil CH",
        details: "UX/UI Designer",
        image: suneelImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:sunil.ch@deskala.in ",
        linkdinUrl: "https://www.linkedin.com/in/suneel-kumar-234844220"
      }
    ]
  },
  {
    row1: [
      {
        name: "Chetan Malviya",
        details: "Sr. Software Developer",
        image: chetanImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:chetan.malviya@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/devvrat02/"
      },
      {
        name: "Rahul Yadav",
        details: "Sr. Software Developer",
        image: rahulImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:rahul.y@deskala.in ",
        linkdinUrl: "https://www.linkedin.com/in/rahulyadav96"
      }
    ],
    row2: [
      {
        name: "Rohit Singh Solanki",
        details: "Sr. Software Developer",
        image: rohitImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:rohit.solanki@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/rohit-singh-solanki-924119147/"
      },
      {
        name: "Sanjiv Sahani",
        details: "Sr. Software Developer",
        image: sanjeevImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:sanjiv.sahani@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/sanjiv-sahani-22332120a/"
      }
    ]
  },
  {
    row1: [
      {
        name: "Rishika Rathore",
        details: "Software Developer",
        image: rishikaImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:rishika.rathore@deskala.in ",
        linkdinUrl: "https://www.linkedin.com/in/rishika-rathore-rishika/"
      },
      {
        name: "Kritika Singh",
        details: "Software Developer",
        image: kritikaImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:kritika@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/kritika-singh-847225244/"
      },
    ],
    row2: [
      
      
      {
        name: "Sidhardh Balaji",
        details: "Marketing and Branding Strategist",
        image: Sidharh,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:sidhardh.balaji@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/sidhardh-balaji/"
      }
    ]
  }
];

export const teamCarouselData = [
  {
    row1: [
      {
        name: "Porus Rathore",
        details: (
          <>
            CEO
            <br></br>
            Leader | Serial Entrepreneur | Product Strategy Expert
          </>
        ),
        image: porusImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:porus.rathore@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/porusrathore/"
      },
      {
        name: "Priyanka Ganguly",
        details: (
          <>
            CFO
            <br></br>
            Business Development Expert
          </>
        ),
        image: priyankaImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:priyanka.ganguly@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/priyankaganguly "
      },
      {
        name: "Alosia Rose",
        details: "Marketing Head",
        image: alosiaImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:alosia.rose@deskala.in ",
        linkdinUrl: "https://www.linkedin.com/in/alosiasheelarose/"
      },

      
    ],
    row2: [
      {
        name: "Chetan Malviya",
        details: "Sr. Software Developer",
        image: chetanImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:chetan.malviya@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/devvrat02/"
      },
      {
        name: "Rahul Yadav",
        details: "Sr. Software Developer",
        image: rahulImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:rahul.y@deskala.in ",
        linkdinUrl: "https://www.linkedin.com/in/rahulyadav96"
      },
      {
        name: "Rohit Singh Solanki",
        details: "Sr. Software Developer",
        image: rohitImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:rohit.solanki@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/rohit-singh-solanki-924119147/"
      },
      
    ]
  },
  {
    row1: [
      {
        name: "Sanjiv Sahani",
        details: "Sr. Software Developer",
        image: sanjeevImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:sanjiv.sahani@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/sanjiv-sahani-22332120a/"
      },
      {
        name: "Rishika Rathore",
        details: "Software Developer",
        image: rishikaImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:rishika.rathore@deskala.in ",
        linkdinUrl: "https://www.linkedin.com/in/rishika-rathore-rishika/"
      },
      {
        name: "Kritika Singh",
        details: "Software Developer",
        image: kritikaImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:kritika@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/kritika-singh-847225244/"
      },
      
      
    ],
    row2: [
      
      {
        name: "Sunil CH",
        details: "UX/UI Designer",
        image: suneelImage,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:sunil.ch@deskala.in ",
        linkdinUrl: "https://www.linkedin.com/in/suneel-kumar-234844220"
      },
      {
        name: "Sidhardh Balaji",
        details: "Marketing and Branding Strategist",
        image: Sidharh,
        mailImg: mailLogo,
        linkdinImg: linkdinLogo,
        mailUrl: "mailto:sidhardh.balaji@deskala.in",
        linkdinUrl: "https://www.linkedin.com/in/sidhardh-balaji/"
      }
    ]
  }
];
// {
//   name: "Naveen L",
//   details: (
//     <>
//       CDO
//       <br></br>
//       Product Design Expert
//     </>
//   ),
//   image: naveenImage,
//   mailImg: mailLogo,
//   linkdinImg: linkdinLogo,
//   mailUrl: "mailto:naveen.lingam@deskala.in",
//   linkdinUrl: "https://www.linkedin.com/in/naveenlingam/"
// },
// {
//   name: "Prakash Hemani",
//   details: (
//     <>
//       CPO
//       <br></br>
//       Product Development Expert
//     </>
//   ),
//   image: prakashImage,
//   mailImg: mailLogo,
//   linkdinImg: linkdinLogo,
//   mailUrl: "mailto:prakash.hemani@deskala.in ",
//   linkdinUrl: "https://www.linkedin.com/in/prakash-hemani-b629a588"
// }
